import _Vocabulary from './model';
import * as _actions from './actions';
import _reducer from './reducer';

_Vocabulary.actions = _actions;

export const Vocabulary = _Vocabulary;
export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/Vocabulary/index.js